module.exports = __webpack_public_path__ + "img/logo.13abda4.svg";